import React from "react";

import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { getPriceFormat } from "shared/functions";

interface AmountBoxProps {
  name?: string | null;
  amount?: string | number;
  note?: string | null;
}

const AmountBox: React.FC<AmountBoxProps> = (props) => {
  const { name, amount, note } = props;

  return (
    <Stack
      direction="column"
      alignItems="center"
      gap={0.5}
      sx={{
        textAlign: "center",
        borderRadius: "8px",
        backgroundColor: "#EDEDED",
        p: "12px 16px",
      }}
    >
      <Typography variant="subtitle2" color="grey800">
        {name || "Сума до сплати"}:
      </Typography>
      <Typography data-testid="amount-value" variant="h3" fontWeight="500">
        {getPriceFormat(Number(amount || 0))} ₴
      </Typography>
      <Typography
        data-testid="payment-purpose-note-value"
        sx={{ wordBreak: "break-word" }}
        variant="subtitle2"
        color="grey800"
      >
        {note || ""}
      </Typography>
    </Stack>
  );
};

export default AmountBox;
